export default __webpack_public_path__ + "static/media/work-from-home.9a84d39d.mp4";